<template>
    <b-form @submit.stop.prevent="saveClicked">
        <b-card class="card-custom">
            <template v-slot:header>
                <h4 class="card-title">Смена пароля</h4>
                <div class="card-toolbar">
                    <b-button type="submit" variant="success">Сохранить</b-button>
                </div>
            </template>
            <b-alert :show="err" :variant="errVariant" class="mb-3">{{errText}}</b-alert>

            <b-form-group id="input-group-curpassword" label-cols="4" label-cols-lg="3"
                          label="Текущий пароль" label-for="input-oldcur">
                <b-form-input id="input-curpassword" v-model="curPassword" type="password" maxlength="100"
                              ref="inputCurPassword"/>
            </b-form-group>
            <b-form-group id="input-group-newpassword" label-cols="4" label-cols-lg="3" maxlength="100"
                          label="Новый пароль" label-for="input-newpassword">
                <b-form-input id="input-newpassword" v-model="newPassword" type="password"
                              ref="inputNewPassword"/>
            </b-form-group>
            <b-form-group id="input-group-confirmpassword" label-cols="4" label-cols-lg="3" maxlength="100"
                          label="Подтверждение" label-for="input-confirmpassword">
                <b-form-input id="input-confirmpassword" v-model="confirmPassword" type="password"
                              ref="inputConfirmPassword"/>
            </b-form-group>
        </b-card>
    </b-form>
</template>

<script>
    import axios from "axios";

    export default {
        name: "AccountPassword",
        data() {
            return {
                userData: this.$store.getters.getUserData,

                err: false,
                errText: "",
                errVariant: "danger",

                loadProcessing: 0,

                curPassword: "",
                newPassword: "",
                confirmPassword: "",


            }
        },
        mounted() {
            this.$nextTick(() => {
                this.$refs.inputCurPassword.$el.focus()
            })
        },
        methods: {
            errTextHide() {
                this.err = false
                this.errText = ""
            },
            errTextShow(msg, variant = "danger", withScroll = true) {
                if (withScroll)
                    window.scrollTo(0, 0)
                this.errText = msg
                this.errVariant = variant
                this.err = true
            },
            saveClicked() {
                this.errTextHide()

                if (this.curPassword.trim().length === 0) {
                    this.errTextShow("Введите текущий пароль.", "info")
                    this.$refs.inputCurPassword.$el.focus()
                    return
                }
                if (this.newPassword.trim().length === 0) {
                    this.errTextShow("Введите новый пароль.", "info")
                    this.$refs.inputNewPassword.$el.focus()
                    return
                }
                if (this.confirmPassword.trim().length === 0) {
                    this.errTextShow("Введите подтверждение пароля.", "info")
                    this.$refs.inputConfirmPassword.$el.focus()
                    return
                }
                if (this.newPassword !== this.confirmPassword) {
                    this.errTextShow("Новый пароль и подтверждение пароля не совпадают.", "info")
                    this.$refs.inputNewPassword.$el.focus()
                    return
                }

                this.loadProcessing++
                axios.post("/ws/ws.svc/ChangePassword", {
                        'Session_UID': this.userData.Session_UID,
                        'CurrentPassword': this.curPassword,
                        'NewPassword1': this.newPassword,
                        'NewPassword2': this.confirmPassword
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)) {
                            this.errTextShow("Неверный формат ответа.")
                        } else {
                            if (resp.data.success) {
                                this.errTextShow("Данные успешно изменены!", "info")
                                this.curPassword = ""
                                this.newPassword = ""
                                this.confirmPassword = ""
                                this.$refs.inputCurPassword.$el.focus()
                            } else {
                                this.errTextShow(resp.data.response.toString())
                            }
                        }

                        this.loadProcessing--
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при обработке данных (" + err.message + ")")
                        this.loadProcessing--
                    })
            }
        },
        watch: {
            operationProcessing: function () {
                this.$store.commit('set', ["showSpinner", this.loadProcessing > 0])
            },
        }

    }
</script>

<style scoped>

</style>